import React from "react";
import Helmet from "react-helmet";
import styled from "styled-components";
import SEO from "../components/Accessories/SEO";
import config from "../../data/SiteConfig";
import content from "../../data/indexContent";
import Hero from "../components/IndexContent/HomeHero";
import FullWidthSection from "../components/UI/FullWidthSection";

import CtaButtonSm from "../components/UI/CtaButtonSm";
import ContentGrid from "../components/IndexContent/features_grid";
import ChecklistBlurb from "../components/IndexContent/checklist_section";
import TestimonialSection from "../components/IndexContent/testimonial_section";

class Index extends React.Component {
  render() {
    const postEdges = this.props.data.allMarkdownRemark.edges;
    return (
      <HomeContainer>
        <Helmet title={config.siteTitle} />
        <SEO postEdges={postEdges} />
        {/*HERO SECTION*/}
        <Hero
          headline={"We make enterprise software easier."}
          description={"home"}
        />
        {/*FEATURES SECTION*/}
        <FullWidthSection bgColor={"#171717"}>
          <div className="features-section-head">
            <h4>Features</h4>
            <p>{content.featureMain}</p>
          </div>
          <ContentGrid />
        </FullWidthSection>
        <EllipseBackground />
        {/*CHECKLIST SECTION*/}
        <ChecklistBlurb />
        {/*TESTIMONIALS*/}
        <TestimonialSection />
        {/*PRICING SECTION*/}
        <CtaSection>
          <div className="ctaBlurb">
            <div className="header">
              <h2>Pricing that Scales with You</h2>
              <h3>about 1&#162; per transaction.</h3>
            </div>
            <p>
              Learn how AppTree can help your business. Contact us to schedule a
              demonstration.
            </p>
            <CtaButtonSm to={"/pricing"} bgColor={"#FF611D"} textColor={"#fff"}>
              View Pricing
            </CtaButtonSm>
          </div>
        </CtaSection>
      </HomeContainer>
    );
  }
}

const CtaSection = styled.div`
  background: #43ab60;
  padding: 25px 0;
`;

const HomeContainer = styled.section`
  min-height: 100vh;
  max-width: 100vw;
  .blurb {
    padding: 100px 0;
  }
  .section-title {
    margin: 0 0 50px 0;
    
    @media screen and (max-width: 768px) {
       width: 80%;
       margin: 0 auto 50px;
    }
  }
  .features-section-head {
    text-align: center;
    margin-bottom: 40px;
    
    p {
      font-size: 1.8rem;
      color: white;
      width: 75%;
      margin: auto;
    }

    h4 {
      color: #ff611d;
      text-transform: uppercase;
      font-weight: 400;
      font-size: 2.5rem;
    }
  }
 
  .ctaBlurb {
    text-align: center;
    display: grid;
    grid-template-rows: 100% 100% 100%;
    grid-gap: 20px;
    h2, h3, p {
      color: white;
    }
    }
    
  }
`;

const EllipseBackground = styled.div`
  background-image: url(https://res.cloudinary.com/ericwindmill/image/upload/v1515343590/apptree_www/bgEllipseFinal.png);
  background-repeat: no-repeat;
  background-size: contain;
  height: 50px;
  margin: -2px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export default Index;

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(
      limit: 2000
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            tags
            cover
            date
            author
            month
            year
            description
            external
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.jsx